// Color file-type icons served from the boardinfinitycoloricons CDN bucket. Mirrors tenant-admin's
// getIconByFileType (containers/CompanyPortal/Jobs/Post/UploadPdf.tsx), keyed by file extension.
// Served through the public CDN (the raw S3 bucket URL answers 403, which rendered as a broken image).
const CDN_BASE = "https://cdn.boardinfinity.com/boardinfinitycoloricons";

// Filenames are used verbatim as they exist in the bucket (including the pre-existing casing/typos).
const FILE_ICON_BY_EXT: Record<string, string> = {
  csv: `${CDN_BASE}/csvFileIcon.svg`,
  doc: `${CDN_BASE}/docFileIcon.svg`,
  docx: `${CDN_BASE}/docxFileicon.svg`,
  xls: `${CDN_BASE}/excelFileicon.svg`,
  xlsx: `${CDN_BASE}/xslxfFileicon.svg`,
  ipynb: `${CDN_BASE}/IPYNB+File+Icon.svg`,
  jpeg: `${CDN_BASE}/jpegFileicon.svg`,
  jpg: `${CDN_BASE}/jpgFileicon.svg`,
  png: `${CDN_BASE}/pngFileicon.svg`,
  ppt: `${CDN_BASE}/pptFileicon.svg`,
  pptx: `${CDN_BASE}/pptxFileicon.svg`,
  svg: `${CDN_BASE}/svgFileicon.svg`,
  pdf: `${CDN_BASE}/pdfFileIcon.svg`,
  zip: `${CDN_BASE}/zipFileIcon.svg`
};

// Extract the lowercase extension from a filename or URL (query/hash stripped).
const getExtension = (nameOrUrl?: string): string => {
  if (!nameOrUrl) return "";
  const path = nameOrUrl.split(/[?#]/)[0];
  const base = path.split("/").pop() || "";
  const dot = base.lastIndexOf(".");
  return dot >= 0 ? base.slice(dot + 1).toLowerCase() : "";
};

// Resolve a CDN color icon for the given filename/URL, or undefined when the extension has no mapping.
export const getFileIconUrl = (nameOrUrl?: string): string | undefined => FILE_ICON_BY_EXT[getExtension(nameOrUrl)];
